export default __webpack_public_path__ + "static/media/image.radus28-software-solution.65155c85.png";